/* 🤖 this file was generated by svg-to-ts */
export const matIconColorize: {
  name: 'colorize';
  data: string;
} = {
  name: 'colorize',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m17.66 5.41.92.92-2.69 2.69-.92-.92 2.69-2.69M17.67 3c-.26 0-.51.1-.71.29l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42l-2.34-2.34c-.2-.19-.45-.29-.7-.29zM6.92 19 5 17.08l8.06-8.06 1.92 1.92L6.92 19z"/></svg>`
};
